<div class="modal-content">
  @if (assetField) {
    <form novalidate [formGroup]="editForm" (keyup.enter)="(assetField.field.canonical_name === 'group_ids' || editForm.valid) && saveEditedAsset()">
      @if (assetField.field.input_type !== 'select' && assetField.field.input_type !== 'date' && assetField.field.input_type !== 'multi-select') {
        <ah-asset-field-input
        [group]="editForm" [field]="assetField.field" [required]="assetField.departmentField.required" [autoFocus]="true"></ah-asset-field-input>
      }
      @if (assetField.field.type === 'MULTI_PICKLIST' && assetField.field.canonical_name !== 'group_ids') {
        <ah-multi-select-input
        [allOptions]="options$ | async" [asset]="asset" [selectedOptions]="selectedOptions" [group]="editForm" [field]="assetField.field" [controlName]="assetField.field.canonical_name"></ah-multi-select-input>
      }
      @if (assetField.field.input_type === 'select') {
        <ah-asset-field-input [group]="editForm" [field]="assetField.field" [required]="assetField.departmentField.required"
        [options]="options$ | async" [disabled]="!(options$ | async).length" [autoFocus]="true" (change)="saveEditedAsset()"></ah-asset-field-input>
      }
      @if (assetField.field.input_type === 'date') {
        <ah-asset-field-input [group]="editForm" [field]="assetField.field" [required]="assetField.departmentField.required"
        [autoFocus]="true" (change)="saveEditedAsset()"></ah-asset-field-input>
      }
      @if (assetField.field.canonical_name === 'group_ids') {
        <ah-group-input [selectedGroups]="selectedGroups" [selectedSubGroups]="selectedSubGroups"
          [divisionGroups]="divisionGroups$ | async" [franchiseGroups]="franchiseGroups$ | async" [notDivisionGroups]="notDivisionGroups$ | async"
          [notFranchiseGroups]="notFranchiseGroups$ | async" [allGroups]="allGroups$ | async" [studioId]="asset.studio_id"
          [franchiseTable]="isFranchiseTable" [divisionTable]="isDivisionTable" [eventTable]="isEventTable"
          [franchiseGroupTable]="isFranchiseGroupTable" [divisionGroupTable]="isDivisionGroupTable"
          [franchiseSubGroupTable]="isFranchiseSubGroupTable" [divisionSubGroupTable]="isDivisionSubGroupTable"
        [franchiseId]="asset.franchise_id" [franchise]="franchise" [divisionId]="asset.division_id"></ah-group-input>
      }
    </form>
  }
  @if (!assetField) {
    <div>
      {{ editError }}
    </div>
  }
</div>
